import { combineReducers } from "redux";
import orderReducer from "@App/state/reducers/orderReducer";
import filterReducer from "@App/state/reducers/filters";
import authReducer from "@App/state/reducers/auth";
import vehicleReturnPickupSlice from "@App/state/reducers/vehicleReturn";
import fleetReducer from "@App/state/reducers/fleet";
import analyticsReducer from "@App/state/reducers/analytics";
import callbackRefReducer from "@App/state/reducers/callbackRef";

const reducers = combineReducers({
  orders: orderReducer,
  filters: filterReducer,
  auth: authReducer,
  vehicleReturnPickup: vehicleReturnPickupSlice,
  fleet: fleetReducer,
  analytics: analyticsReducer,
  callbackRef: callbackRefReducer,
});

export default reducers;

// compile all reducers to a single state that we can use in hooks
export type State = ReturnType<typeof reducers>;
